import { SortingAction, UPDATE_SORT, sortingPayload } from "../actions/sorting";

const initialState = [];

export const localStorageSortingLocation = 'global-sorting';
export const sortingInitializer = (initialValue = initialState) =>
  JSON.parse(localStorage.getItem(localStorageSortingLocation)) || initialValue;

export const sortReducer = (state: sortingPayload[], action: SortingAction) => {
  const newState = state.find(
    item =>
      item.pageName === action.payload.pageName && item.environment === action.payload.environment
  );
  switch (action.type) {
    case UPDATE_SORT:
      return newState
        ? state.map(item => {
            return item.pageName === action.payload.pageName
              ? {
                  ...action.payload
                }
              : item;
          })
        : [...state, { ...action.payload }];

    default:
      return state;
  }
};